import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format date to DD/MM/YYYY
export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB');
}

// Format currency
export function formatCurrency(amount) {
  if (amount === null || amount === undefined) return '₹0.00';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  }).format(amount);
}

// Get status badge class
export function getStatusClass(status) {
  const statusMap = {
    'LIVE': 'status-live',
    'SENT FOR APPROVAL': 'status-sent-for-approval',
    'APPROVED': 'status-approved',
    'REJECTED': 'status-rejected',
    'PAID': 'status-paid',
    'CANCELLED': 'status-cancelled',
  };
  return statusMap[status] || 'bg-gray-100 text-gray-800';
}

// Check if user has permission
export function hasPermission(userPosition, requiredPositions) {
  return requiredPositions.includes(userPosition);
}

// Role-based menu items
export function getMenuItems(userPosition) {
  const baseItems = [
    { label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' },
  ];

  const claimItems = [
    { label: 'New Claim', path: '/claims/new', icon: 'Plus' },
    { label: 'My Claims', path: '/claims', icon: 'FileText' },
  ];

  const approvalItems = [
    { label: 'Pending Approvals', path: '/approvals', icon: 'CheckCircle' },
  ];

  const paymentItems = [
    { label: 'Pending Payments', path: '/payments', icon: 'CreditCard' },
  ];

  const reportItems = [
    { label: 'Daily Reports', path: '/reports/daily', icon: 'Calendar' },
  ];

  const misItems = [
    { label: 'MIS Reports', path: '/mis', icon: 'BarChart3' },
  ];

  const settingsItems = [
    { label: 'Change Password', path: '/profile/password', icon: 'Lock' },
  ];

  // CVO, CEO - View MIS only
  if (['CVO', 'CEO'].includes(userPosition)) {
    return [...baseItems, ...misItems, ...settingsItems];
  }

  // Federation President - Approve claims + Payment + MIS
  if (userPosition === 'Federation-President') {
    return [...baseItems, ...approvalItems, ...paymentItems, ...misItems, ...settingsItems];
  }

  // Finance Head - Payments + MIS
  if (userPosition === 'Fed-Finance-Head') {
    return [...baseItems, ...paymentItems, ...misItems, ...settingsItems];
  }

  // Site Management Head - Approve final claims + View reports + MIS
  if (userPosition === 'Fed-Site-Mgt-Head') {
    return [...baseItems, ...approvalItems, ...reportItems, ...misItems, ...settingsItems];
  }

  // RBO Head - Can apply + approve claims
  if (userPosition === 'RBO-Head') {
    return [...baseItems, ...claimItems, ...approvalItems, ...settingsItems];
  }

  // Field Staff - Can apply claims
  if (['RBO-Deputy Head', 'Field Manager', 'Additional Field Manager', 'Wealth Advisor'].includes(userPosition)) {
    return [...baseItems, ...claimItems, ...settingsItems];
  }

  // Project Site Manager - Daily reporting
  if (userPosition === 'Project Site Manager') {
    return [...baseItems, ...reportItems, ...settingsItems];
  }

  return [...baseItems, ...settingsItems];
}

// Get greeting based on time
export function getGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good Morning';
  if (hour < 17) return 'Good Afternoon';
  return 'Good Evening';
}

// Download blob as file
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
